// Keep uploaded images intact; replace only Stoat's generated default avatars.
export function isDefaultAvatar(src?: string) {
  if (!src) return false;
  try {
    return /\/users\/[^/]+\/default_avatar\/?$/.test(
      new URL(src, "https://lw.invalid").pathname,
    );
  } catch {
    return false;
  }
}
